import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import CampaignList from "./CampaignList";
import { THEME } from "../_constants";
import Campaign from "../_helpers/campaign";

const styles = theme => ({
    dashboard: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        backgroundColor: THEME.COLOR.GRAY
    }
});

class PaperSheet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDataAvailable: props.campaigns.items ? true : false,
            campaignGroups: {}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.campaigns.items &&
            nextProps.districts &&
            nextProps.districts.length > 0
        ) {
            let districtsObj = {};
            nextProps.districts.map(district => {
                districtsObj[district.code] = district;

                return district;
            });

            Object.keys(nextProps.campaigns.items).map(key => {
                let list = nextProps.campaigns.items[key];

                list.map(campaign => {
                    Campaign.normalizeCampaign(campaign, districtsObj);

                    return campaign;
                });

                return key;
            });

            let campaignGroups = this.getCampaignGroups(
                nextProps.campaigns.items
            );

            this.setState({
                isDataAvailable: true,
                districtsObj: districtsObj,
                campaignGroups: campaignGroups
            });
        }
    }

    getCampaignGroups(groupsObj) {
        return groupsObj;
    }

    render() {
        const { classes } = this.props;
        const { campaignGroups } = this.state;

        return this.state.isDataAvailable ? (
            <div className={classes.dashboard}>
                <CampaignList
                    group={"NOT_STARTED"}
                    campaigns={campaignGroups.NOT_STARTED ? campaignGroups.NOT_STARTED : []}
                    districtsObj={this.state.districtsObj}
                />
                <CampaignList
                    group={"STARTED"}
                    campaigns={campaignGroups.STARTED ? campaignGroups.STARTED : []}
                    districtsObj={this.state.districtsObj}
                />
                <CampaignList
                    group={"FINISHED"}
                    campaigns={campaignGroups.FINISHED ? campaignGroups.FINISHED : []}
                    districtsObj={this.state.districtsObj}
                />
            </div>
        ) : (
            <div className={classes.dashboard} />
        );
    }
}

PaperSheet.propTypes = {
    classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { authentication, campaigns } = state;
    const { user } = authentication;
    const { districts } = state.location;
    return {
        user,
        campaigns,
        districts
    };
}

const connectedPaperSheet = connect(mapStateToProps)(PaperSheet);

export default withStyles(styles)(
    translate("translations")(connectedPaperSheet)
);



// WEBPACK FOOTER //
// ./src/HomePage/Dashboard.js